var _rect, _circle, _circle2, _g, _circle3, _circle4, _circle5, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestionMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 200,
    fill: "#F7F7F7"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 100,
    r: 80,
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_749_10524",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 20,
    y: 20,
    width: 160,
    height: 160
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 100,
    r: 80,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_749_10524)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-18 183L157.803 25H160.159L100.205 183H-18Z",
    fill: "#5222D0",
    fillOpacity: 0.05
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 34.5,
    cy: 43.5,
    r: 2,
    stroke: "#5222D0"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 162.5,
    cy: 20.5,
    r: 2,
    stroke: "#5222D0"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 28.5,
    cy: 163.5,
    r: 2,
    stroke: "#5222D0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M93.6133 113.407C93.6133 110.451 94.0778 107.833 95.0067 105.553C96.02 103.273 97.2445 101.247 98.68 99.4733C100.2 97.7 101.804 96.0533 103.493 94.5333C105.182 93.0133 106.744 91.5778 108.18 90.2267C109.7 88.7911 110.924 87.3133 111.853 85.7933C112.867 84.2733 113.373 82.5845 113.373 80.7267C113.373 77.6867 112.107 75.2378 109.573 73.38C107.124 71.5222 103.831 70.5933 99.6933 70.5933C95.7245 70.5933 92.1778 71.4378 89.0533 73.1267C85.9289 74.7311 83.3533 77.0111 81.3267 79.9667L66 70.9733C69.3778 65.8222 74.0644 61.7267 80.06 58.6867C86.0556 55.5622 93.3178 54 101.847 54C108.18 54 113.753 54.9289 118.567 56.7867C123.38 58.56 127.138 61.1778 129.84 64.64C132.627 68.1022 134.02 72.3667 134.02 77.4333C134.02 80.7267 133.513 83.64 132.5 86.1733C131.487 88.7067 130.178 90.9022 128.573 92.76C126.969 94.6178 125.238 96.3489 123.38 97.9533C121.607 99.5578 119.918 101.12 118.313 102.64C116.709 104.16 115.358 105.764 114.26 107.453C113.247 109.142 112.74 111.127 112.74 113.407H93.6133ZM103.24 145.2C99.6933 145.2 96.78 144.06 94.5 141.78C92.22 139.5 91.08 136.798 91.08 133.673C91.08 130.464 92.22 127.804 94.5 125.693C96.78 123.498 99.6933 122.4 103.24 122.4C106.871 122.4 109.784 123.498 111.98 125.693C114.26 127.804 115.4 130.464 115.4 133.673C115.4 136.798 114.26 139.5 111.98 141.78C109.784 144.06 106.871 145.2 103.24 145.2Z",
    fill: "#F09A37"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionMark);
export default __webpack_public_path__ + "static/media/question_mark.cb9a4dc6501fdea8050582b9be096811.svg";
export { ForwardRef as ReactComponent };